<template>
  <div class="page-layout-masonry">
    <div class="container">
      <p class="title">
        Masonry Layout.
      </p>
      <p class="subtitle" style="margin-bottom:30px;">
        Creating Pinterest-like Masonry layout.<br />
        Reference: <a href="https://www.sitepoint.com/understanding-masonry-layout/" target="_blank">Sitepoint - Understanding Masonry Layout</a><br /><br />
        <a href="https://github.com/shershen08/vue-masonry"><i class="fa fa-2x fa-github color-red"></i>  &nbsp;&nbsp;shershen08 / Vue-Masonry</a>
      </p>
      <div class="grid" data-masonry='{ "columnWidth": 200 }' style="display:none;">
        <div v-for="image in images" class="grid-item">
          <!--<div style="min-height:200px;"
            :style="{ 'background-image': 'url('+ image.image_900 +')' }">
          </div>-->
          <img :src="image.image_900" class="img-responsive" />
        </div>
      </div>

    </div>
    <div class="container masonry-container">

      <div class="masonry-wrapper" v-masonry transition-duration="0.3s" item-selector=".masonry-item" is-fit-width="true" data-masonry-options="{ 'isFitWidth': true }">

        <div v-masonry-tile class="masonry-item" v-for="(image, index) in images">
          <!-- block item markup
          <img :src="image.image_900" class="img-responsive" style="width:100%;" /> -->
          <div class="card">
            <div class="card-image">
              <figure class="image">
                <img :src="image.image_900" alt="Image">
              </figure>
            </div>
            <div class="card-content">
              <div class="media">
                <div class="media-left">
                  <figure class="image is-48x48">
                    <img src="http://bulma.io/images/placeholders/96x96.png" alt="Image" style="border-radius:30px;">
                  </figure>
                </div>
                <div class="media-content">
                  <p class="title is-4">{{ image.title }}</p>
                  <p class="subtitle is-6">@{{ image.title.replace(/\s+/g, '') }}</p>
                </div>
              </div>

              <div class="content">
                {{ image.description }} <a>@architecture</a>.
                <a>#elegant</a> <a>#design</a>
                <br>
                <!--<small>11:09 PM - 1 Jan 2016</small>-->
                <small>{{ image.created_at | datetime }}</small>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="control notification is-danger" v-if="error">
        <button class="delete" @click="error = undefined"></button>
        {{ error }}
      </div>
    </div>

    <section-comment style="margin-top:50px;"></section-comment>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import auth from '@/apis/Auth'
export default {
  data () {
    return {
      images: [],
      error: undefined
    }
  },
  computed: mapGetters([
    'evenOrOdd',
    'isAuthenticated'
  ]),
  methods: {
    test () {
    },
    refresh: function () {
      auth.gallery()
      .then(data => {
        console.log('get gallery')
        console.log(data)
        this.images = data
      })
      .catch(error => {
        console.log('invalid get gallery', error)
        this.images = []
        this.error = error.error
      })
    },
    ...mapActions([
      'authenticated',
      'unauthenticated'
    ])
  },
  beforeCreate () {
  },
  created () {
    console.log('created LayoutMasonry.vue')
  },
  mounted () {
    console.log('mounted LayoutMasonry.vue')
    this.$scrollTo(0)
    this.refresh()
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-layout-masonry {
  padding-top: 60px;
}

.masonry-container {
  margin: 0 auto;
}

.masonry-item {
  margin: 0 auto 0 auto;
  padding: 10px;
  width: 100%;

  @media screen and (min-width: $tablet) {
    width: 50%;
  }

  @media screen and (min-width: $desktop) {
    width: 33.33%;
  }
}
</style>



// WEBPACK FOOTER //
// LayoutMasonry.vue?b8380c22